/**
 * Los guardados del día, EN COLA, uno detrás de otro (16-10).
 *
 * El servidor protege el día con su versión (`base_updated_at`): si alguien lo cambió
 * después de que la pantalla lo cargara, se queda con lo suyo. Sin cola, con la red lenta
 * salía un segundo guardado antes de que volviera el primero, con la versión de antes de
 * ese primero: el servidor lo tomaba por una copia vieja y tiraba lo que traía. La propia
 * pantalla se pisaba a sí misma.
 *
 * Dos reglas:
 *
 *   1. Cada tarea sale cuando termina la anterior, y lee la versión de su día al salir.
 *      Que la anterior no se cuelgue para siempre es cosa de la tarea: el guardado lleva
 *      su tope (`lib/fetchConTope`).
 *   2. `invalidar(fecha)`: cuando un guardado de esa fecha choca con un cambio hecho en
 *      otro sitio, lo que ya estaba en cola para ella lleva una foto que el servidor acaba
 *      de rechazar. Mandarlo con la versión nueva pisaría justo lo que se protegió, así que
 *      no sale: la pantalla recarga el día y lo siguiente parte de ahí.
 *
 * `poner` devuelve lo que devuelva la tarea, o `null` si no salió por la regla 2.
 */
export const crearColaDeGuardado = () => {
    let ultimo = Promise.resolve();
    let enVuelo = 0;
    const epocas = {};

    return {
        ocupada: () => enVuelo > 0,
        invalidar: (fecha) => { epocas[fecha] = (epocas[fecha] || 0) + 1; },
        poner: (fecha, tarea) => {
            const epoca = epocas[fecha] || 0;
            enVuelo += 1;
            const turno = ultimo
                .then(() => ((epocas[fecha] || 0) !== epoca ? null : tarea()))
                .finally(() => { enVuelo -= 1; });
            ultimo = turno.catch(() => {});
            return turno;
        },
    };
};
